import { GET } from "../../APiHelper/API";

export const getTransferedPlayersAPI = (team_id, onSuccess, onError) => {


    GET(`/api/v1/leagues/team/${team_id}/transferred_players`, onSuccess, onError)
}